import React, { useEffect, useState } from "react";
import loginstyle from "./Login.module.css";
import basestyle from "../Base.module.css";
import "./index.css";
import Loader from "../../Components/Loader";
import GeneralToast from "../../Components/Toaster";
import { setStorageItem } from "../../Utils/storage";
import { useNavigate } from "react-router-dom";
import { useTriggerEmailOtp } from "../../API/Queries/useTriggerEmailOtp";

const LoginOtp = () => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const {
    data,
    isLoading: triggerEmailOtpLoading,
    isError,
    error,
    mutate: triggerOtp,
  } = useTriggerEmailOtp();

  const handleEmailChange = (e) => {
    const { value } = e.target;
    setEmail(value);
  };

  const verifyEmail = () => {
    if (!email?.endsWith("@ninjacart.com")) {
      setErrorMessage("Enter Ninjacart email id");
      return false;
    }
    return true;
  };

  const triggerOtpHandle = (e) => {
    e.preventDefault();
    if (!verifyEmail) {
      return;
    }
    setErrorMessage("");
    setStorageItem("email", email);
    const payload = {
      input: {
        identity: email,
      },
    };

    triggerOtp(payload);
  };

  useEffect(() => {
    if (data && data?.data?.status === 200) {
      navigate("/otp-verify");
    }
    if (isError) {
      setErrorMessage(
        error?.response?.data?.errorMessage ||
          error?.message ||
          "Something went wrong"
      );
    }
  }, [data, isError, error, navigate]);

  return (
    <>
      {triggerEmailOtpLoading && <Loader />}
      <div className={loginstyle.parentContainer}>
        <div className={loginstyle.login}>
          <form onSubmit={triggerOtpHandle}>
            <p className="text-xl font-semibold mt-2 mb-4">Login</p>
            <p className="flex items-start font-semibold mb-2">
              Enter e-mail ID
            </p>

            <div className="input-container flex items-center justify-center gap-4 mb-4">
              <input
                type="text"
                name="email"
                value={email}
                placeholder="Enter your email"
                onChange={handleEmailChange}
              />
            </div>
            <button
              type="submit"
              className={basestyle.button_common}
              style={{ opacity: email?.endsWith("@ninjacart.com") ? 1 : 0.5 }}
              disabled={!email?.endsWith("@ninjacart.com")}
            >
              {triggerEmailOtpLoading ? "Loading..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
      {errorMessage && <GeneralToast type="error" message={errorMessage} />}
    </>
  );
};

export default LoginOtp;
